module.exports = __webpack_public_path__ + "img/emsFA4.5fa13c99.png";